import React, {CSSProperties, FunctionComponent} from "react";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {createMuiTheme} from "@material-ui/core";
import {ThemeProvider} from "@material-ui/styles";
import theme from "../theme";

import {MuiPickersOverrides} from "@material-ui/pickers/typings/overrides";
import {Moment} from "moment";
import DateFnsUtils from "@date-io/moment";

type overridesNameToClassKey = {
    [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};

declare module "@material-ui/core/styles/overrides" {
    export interface ComponentNameToClassKey extends overridesNameToClassKey {
    }
}

const materialTheme = createMuiTheme({
    ...theme,
    palette: {
        primary: {
            main: "#71C8CD"
        },
        secondary: {
            main: "#fff"
        },
        text: {
            secondary: "#999"
        }
    },
    shape: {
        borderRadius: 10
    },
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                background: "linear-gradient(to right, #71C8CD, #DB9649, #E25843)"
            }
        },
        //@ts-ignore
        MuiPickersToolbarText: {
            toolbarBtnSelected: {
                color: "rgb(0,0,0,0.6)"
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottom: "1px solid #71C8CD"
                },
                "&:hover:not($disabled):not($error):not($focused):before": {
                    borderBottom: "2px solid #71C8CD"
                }
            }
        }
    }
});

type CommonDatePickerProps = {
    label: string;
    value: Moment | null;
    onSelectDate: (date: Moment | null) => void;
    inputStyle?: CSSProperties;
    minDate?: Moment;
    maxDate?: Moment;
    maxDateMessage?: string;
    shouldDisableDate?: (date: Moment | null) => boolean;
    minDateMessage?: string;
    error?: boolean;
    errorText?: string;
    disableFuture?: boolean;
    disablePast?: boolean;
    openTo?: "date" | "year" | "month";
    views?: Array<"year" | "date" | "month">;
    autoOk?: boolean;
};

const DatePicker: FunctionComponent<CommonDatePickerProps> = (
    {autoOk, openTo, views, label, value, onSelectDate, inputStyle, minDateMessage, shouldDisableDate, minDate, maxDate, maxDateMessage, error, errorText, disableFuture, disablePast}) => (
    <ThemeProvider theme={materialTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                id="date-picker-dialog"
                label={label}
                format="DD.MM.YYYY"
                minDate={minDate}
                maxDate={maxDate}
                autoOk={autoOk}
                minDateMessage={minDateMessage}
                maxDateMessage={maxDateMessage}
                shouldDisableDate={shouldDisableDate}
                value={value}
                invalidDateMessage={"ungültig"}
                onChange={onSelectDate}
                style={{width: "100%", ...inputStyle}}
                error={error}
                helperText={errorText}
                disableFuture={disableFuture}
                disablePast={disablePast}
                openTo={openTo}
                views={views}
            />
        </MuiPickersUtilsProvider>
    </ThemeProvider>
);


export default DatePicker;
